import React, { Component } from 'react';
import { GeckoModal, GeckoModalService, GeckoDialogService } from 'ui';
import BotTagManagerService from '../Service';
import { renderError } from 'services/gecko-error';

class BotTagManagerModal extends Component {
  state = {
    tag: this.props.tag,
  };

  fields = [
    {
      label: 'Name',
      key: 'name',
      width: '100%',
      required: true,
    },
  ];

  saveHandler() {
    return BotTagManagerService.http
      .update(this.state.tag)
      .then((tag) => {
        // Update tags list
        BotTagManagerService.dispatch.updateTag(tag);
        // Close Modal
        new GeckoModalService().close({ action: 'save', tag: tag });
      })
      .catch(renderError);
  }

  removeHandler() {
    return BotTagManagerService.http
      .remove(this.state.tag)
      .then(() => {
        // Update tags list
        BotTagManagerService.dispatch.deleteTag(this.state.tag);
        // Close Modal
        new GeckoModalService().close({
          action: 'remove',
          tag: this.state.tag,
        });
      })
      .catch(renderError);
  }

  footerBtns = [
    {
      preset: 'save',
      handler: this.saveHandler.bind(this),
    },
    {
      preset: 'remove',
      secondary: true,
      handler: () => {
        new GeckoDialogService()
          .confirm(
            'Are you sure you want to delete this tag? This tag will be removed from all answers and skills that it was applied to.'
          )
          .then((ok) => {
            if (ok) {
              this.removeHandler();
            }
          });
      },
    },
  ];

  changeHandler(key, val) {
    const newValues = Object.assign({}, this.state.tag, { [key]: val });
    this.setState({ tag: newValues });
  }

  render() {
    return (
      <GeckoModal
        name="Edit Tag"
        fields={this.fields}
        values={this.state.tag}
        submitHandler={this.saveHandler.bind(this)}
        handler={this.changeHandler.bind(this)}
        btns={this.footerBtns}
      />
    );
  }
}

export default BotTagManagerModal;
